jQuery(document).ready(function ($) {
    const gallery_carousel = new Swiper('.gallery-carousel__carousel', {
        loop: true,

        slidesPerView: 1,

        navigation: {
            prevEl: '.gallery-carousel__arrow-left',
            nextEl: '.gallery-carousel__arrow-right'
        },

        pagination: {
            el: '.gallery-carousel__pagination',
            type: 'bullets',
            bulletClass: 'pagination__bullet',
            bulletActiveClass: 'active',
            clickable: true
        },

        autoplay: {
            delay: 8000,
        },
        speed: 500,

        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },

        //grabCursor: true
    });
});